/// <amd-module name="Wit/QueriesHub/Common/Components/DeleteDialog" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Dialog } from "VSSUI/Dialog";
import { getWorkItemTrackingClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking";
import { QueryItem } from "Wit/Common/QueryUtils/Models";
import * as Resources from "Wit/QueriesHub/Resources";
import { reportError } from "Wit/Common/QueryUtils/ErrorHandlingUtils";

export interface IDeleteDialogProps {
    onDismiss?: () => void;
    onDelete?: () => void;
    pageContext: IVssPageContext;
    projectId: string;
    query: QueryItem;
}

export function DeleteDialog(props: IDeleteDialogProps) {
    return (
        <Dialog
            titleProps={{ text: Resources.ConfirmTitle }}
            onDismiss={() => props.onDismiss?.()}
            footerButtonProps={[
                {
                    text: Resources.Cancel,
                    onClick: () => props.onDismiss?.()
                },
                {
                    text: Resources.OK,
                    onClick: () => deleteQuery(props),
                    primary: true
                }
            ]}
        >
            <div className="scroll-auto flex-grow flex-row">
                <div>
                    <p>{format(Resources.QueryDeleteOperation, props.query.path)}</p>
                </div>
            </div>
        </Dialog>
    );
}

async function deleteQuery(props: IDeleteDialogProps) {
    try {
        await getWorkItemTrackingClient(props.pageContext).deleteQuery(props.projectId, props.query.id);
        props.onDelete?.();
    } catch (error) {
        reportError(props.pageContext, "delete-query", error?.message);
    }
    props.onDismiss?.();
}
